var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { useTranslation } from "react-i18next";
import { Link as RouterLink } from "react-router-dom";
import { Box, Divider, Toolbar, AppBar, CssBaseline, Drawer, useMediaQuery, IconButton, useTheme, Hidden, Typography, } from "@material-ui/core";
import { AccountCircle, Menu } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core/styles";
import { Skeleton } from "@material-ui/lab";
import { Player } from "frontend/src/features/show-player";
import { paths } from "frontend/src/pages/paths";
import { useViewer } from "frontend/src/domain/session";
import { Logo } from "frontend/src/ui/logo";
import { locales } from "frontend/src/domain/localization/i18n";
import { LanguageSwitcher } from "frontend/src/domain/localization";
import { Navigation } from "./navigation";
var drawerWidth = 260;
var useStyles = makeStyles(function (theme) { return ({
    toolbar: __assign({}, theme.mixins.toolbar),
    appBar: {
        marginLeft: drawerWidth,
        width: "calc(100% - " + drawerWidth + ")",
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
    },
    main: {
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        padding: theme.spacing(3),
        paddingBottom: 140,
        width: "100%",
    },
}); });
export var RightholderLayout = function (_a) {
    var _b;
    var children = _a.children;
    var theme = useTheme();
    var classes = useStyles();
    var user = useViewer().user;
    var showPermanentDrawer = useMediaQuery(theme.breakpoints.up("md"));
    var _c = React.useState(false), showDrawer = _c[0], setShowDrawer = _c[1];
    var ready = useTranslation(locales.namespaces.rightholder).ready;
    if (!ready) {
        return null;
    }
    return (React.createElement(Box, { display: "flex" },
        React.createElement(CssBaseline, null),
        React.createElement(AppBar, { position: "absolute", className: classes.appBar },
            React.createElement(Toolbar, { className: classes.toolbar, variant: "dense" },
                React.createElement(Hidden, { mdUp: true },
                    React.createElement(IconButton, { onClick: function () { return setShowDrawer(!showDrawer); } },
                        React.createElement(Menu, null))),
                React.createElement(Box, { display: "flex", ml: "auto", alignItems: "center" },
                    React.createElement(LanguageSwitcher, null),
                    React.createElement(AccountCircle, null),
                    React.createElement(Box, { ml: 1 },
                        React.createElement(Typography, null, (_b = user === null || user === void 0 ? void 0 : user.email) !== null && _b !== void 0 ? _b : React.createElement(Skeleton, { width: 100 })))))),
        React.createElement(Drawer, { variant: showPermanentDrawer ? "permanent" : "temporary", anchor: "left", classes: { root: classes.drawer, paper: classes.drawerPaper }, open: showDrawer, onClose: function () { return setShowDrawer(false); } },
            React.createElement(Box, { display: "flex", alignItems: "center", justifyContent: "center", height: 64 },
                React.createElement(RouterLink, { to: paths.rightholder.home() },
                    React.createElement(Box, { display: "inline-flex", alignItems: "center", justifyContent: "center" },
                        React.createElement(Logo, { height: 40, width: "80%" })))),
            React.createElement(Divider, null),
            React.createElement(Navigation, null)),
        React.createElement(Box, { component: "main", className: classes.main },
            React.createElement(Toolbar, { className: classes.toolbar }),
            React.createElement(Box, { display: "flex", justifyContent: "center" },
                React.createElement(Box, { width: "100%", maxWidth: 1200 }, children))),
        React.createElement(Player, null)));
};
